/* Copyright (c) 2024 Xperi. All Rights Reserved. */

/* eslint-disable no-shadow */
/* eslint-disable no-unused-vars */
export enum PlayerLoadModeStates {
    DESTROYED,
    NOT_LOADED,
    MEDIA_SOURCE,
    SRC_EQUALS,
}
